import { SET_ACTIVE_SUB_LAYER, SET_FHA_TIMELAPSE_PLAYING } from '../constants/actionTypes';

/**
 * Update the active sub-layer for the given view, season, and layer
 * @param {String} layer
 * @param {Any} activeSubLayer
 * @param {Number} view
 * @param {String} [season]
 * @return {Object} action
 */
export function setActiveSubLayer(layer, activeSubLayer, view, season) {
  return {
    type: SET_ACTIVE_SUB_LAYER,
    activeSubLayer,
    layer,
    season,
    view,
  };
}

export function setFhaTimelapsePlaying(isPlaying) {
  return {
    type: SET_FHA_TIMELAPSE_PLAYING,
    isPlaying,
  };
}
